// 3rd Party script! Do not code-review
// TODO: Maybe could be refactored
/* eslint-disable no-var */
/* eslint-disable */

import { Device } from 'DeviceUtils';
import { isTMCZEnv } from 'Options';

var ifrm;
var bodyElement;
var styleString = '.gdpr-dialog-active { overflow: hidden; }';
var currentConsent;

const cookieRecipientsName = 'corec';

const TMOBILE_HOSTNAME = 'tvgo.t-mobile.cz';

window.dataLayer = window.dataLayer || []; // Google Tag Manager

const gcConfig = {
    cocosDelegate: 'https://consent.t-mobile.cz/dialog'
};

export function coComponent(userId) {
    //console.log('gdpr iframe inited');
    var head = document.head || document.getElementsByTagName('head')[0];
    bodyElement = document.body || document.getElementsByTagName('body')[0];
    var style = document.createElement('style');

    head.appendChild(style);
    style.type = 'text/css';
    if (style.styleSheet) {
        // This is required for IE8 and below.
        style.styleSheet.cssText = styleString;
    } else {
        style.appendChild(document.createTextNode(styleString));
    }

    const src = userId ? `${gcConfig.cocosDelegate}?userId=${userId}` : gcConfig.cocosDelegate;

    ifrm = document.createElement('iframe');
    ifrm.setAttribute('src', src);
    ifrm.style.width = '100%';
    ifrm.style.height = '100%';
    ifrm.style.position = 'fixed';
    ifrm.style.display = 'none';
    ifrm.style.top = '0';
    ifrm.style.left = '0';
    ifrm.style.zIndex = '99999';
    ifrm.classList.add('gdpr-iframe');
    bodyElement.appendChild(ifrm);
    //bodyElement.classList.add("gdpr-dialog-active");
}
//delete cookie
function deleteCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
if (Device.isWeb && isTMCZEnv) {
    // TODO: Refactor into function on app run
    // This is temp solution
    window.addEventListener('message', receiveMessage, false);
}

function receiveMessage(event) {
    // console.log('cookie consent loader', { event });
    //console.log('event data');
    //console.log(event.data);
    if (event.data['evName'] == 'openIframe') {
        //console.log('openIframe');
        openIframe();
    }
    if (event.data['evName'] == 'closeIframe') {
        //console.log('closeIframe');
        hideIframe();
    }
    if (event.data['evName'] == 'pushToDL') {
        //console.log('pushToDL');
        //console.log(event.data['dataLayer']);
        if (event.data['dataLayer'].toDelete) {
            //console.log('delete cookies: ');
            //console.log(event.data['dataLayer'].toDelete);
            currentConsent = event.data['dataLayer'].consent;
            // deleting cookies
            event.data['dataLayer'].toDelete.forEach(function (ck) {
                deleteCookie(ck);
                //console.log('deleted: '+ck);
            });
        } else {
            window.dataLayer.push(event.data['dataLayer']);
            console.log({ dataLayer: window.dataLayer });
            currentConsent = event.data['dataLayer'];
        }
    }
}

function getCookieByName(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    var value;
    if (match) {
        value = unescape(match[2]);
    } else {
        value = null;
    }
    return value;
}
function isScriptAllowed(category) {
    console.log('function isScriptAllowed() is obsolete - change to isScriptAllowedRec()');
    var result = false;
    var consentCookie = JSON.parse(getCookieByName(cookieTypesName));
    if (consentCookie != null) {
        Object.keys(consentCookie).forEach(function (key) {
            if (key == category) {
                result = this[key];
            }
        }, consentCookie);
    }
    return result;
}
export function isScriptAllowedRec(category) {
    var result = false;
    var consentCookie = JSON.parse(getCookieByName(cookieRecipientsName));
    console.log('consentCookie: ');
    console.log(consentCookie);
    if (consentCookie != null) {
        Object.keys(consentCookie).forEach(function (key) {
            console.log('key: ' + key);
            if (key == category) {
                result = this[key];
            }
        }, consentCookie);
    }
    console.log('isAllowedRec:', result);
    return result;
}

if (typeof logInited === 'undefined') {
    var logInited = false;
}
function openIframe() {
    // Staging Hack so cookie notice can be closed properly
    if (
        window.location.hostname !== TMOBILE_HOSTNAME &&
        window.dataLayer.length > 0 &&
        typeof window.dataLayer[0].fnCookie !== 'undefined' &&
        window.dataLayer[0].fnCookie !== 'none'
    )
        return;

    const params = new URLSearchParams(window.location.search);
    if (!params.has('dialog')) {
        ifrm.classList.remove('hide');
        ifrm.style.display = 'block';
        bodyElement.classList.add('gdpr-dialog-active');

        if (logInited == false) {
            var msg = {
                action: 'log',
                event: 'dialogPopup',
                eventOpt: 'auto',
                currentURL: document.URL
            };
            ifrm.contentWindow.postMessage(msg, '*');
            logInited = true;
        }
        var msg2 = {
            action: 'initLog',
            event: 'setCurrentUrl',
            currentURL: document.URL
        };
        ifrm.contentWindow.postMessage(msg2, '*');
    }
}
function openIframeManual() {
    ifrm.classList.remove('hide');
    ifrm.style.display = 'block';
    bodyElement.classList.add('gdpr-dialog-active');
    if (logInited == false) {
        var msg = {
            action: 'log',
            event: 'dialogPopup',
            eventOpt: 'manual',
            currentURL: document.URL
        };
        ifrm.contentWindow.postMessage(msg, '*');
        logInited = true;
    }
    var msg2 = {
        action: 'initLog',
        event: 'setCurrentUrl',
        currentURL: document.URL
    };
    ifrm.contentWindow.postMessage(msg2, '*');
}
function hideIframe() {
    ifrm.classList.add('hide');
    ifrm.style.display = 'none';
    bodyElement.classList.remove('gdpr-dialog-active');
    logInited = false;
    location.reload();
}
